import React, { useRef } from 'react';

import { ProtegerPagina } from '../../VerificaPermissaoPage';
import DialogoCarregarNota from './DialogoCarregarNota';
import {} from '../../../utils/dadosTelas';

const TesteLeituraXml = () => {
  const refDialogoCarregarNota = useRef(null);

  function handleOpenCarregarNota() {
    if (refDialogoCarregarNota.current) {
      refDialogoCarregarNota.current.handleOpen();
    }
  }

  return (
    <div>
      <div>TesteLeituraXml</div>
      <button type="button" onClick={handleOpenCarregarNota}>
        Abrir Nota
      </button>
      <DialogoCarregarNota ref={refDialogoCarregarNota} />
    </div>
  );
};

function Wrapper() {
  return (
    <ProtegerPagina permissao="publico">
      <TesteLeituraXml />
    </ProtegerPagina>
  );
}

export default Wrapper;
